import { useContext } from 'react'
import { ErrorStatusContext } from '../providers/ErrorStatusProvider'

export default function useErrorStatus() {
  return useContext(ErrorStatusContext)
}
